import { z } from "zod";
import validUsaZipCodes from "./valid-usa-zip-codes.json";

const usaZipCodePattern = /^\d{5}$/;

let validUsaZipCodeSet: ReadonlySet<string> | undefined;

function getValidUsaZipCodeSet(): ReadonlySet<string> {
  if (!validUsaZipCodeSet) {
    validUsaZipCodeSet = new Set(validUsaZipCodes);
  }

  return validUsaZipCodeSet;
}

function normalizeUsaZipCode(rawValue: string): string {
  const trimmed = rawValue.trim();
  const zipMatch = trimmed.match(/^(\d{5})(?:-?\d{4})?$/);
  return zipMatch ? zipMatch[1] : rawValue;
}

function isValidUsaZipCode(zipCode: string): boolean {
  if (!usaZipCodePattern.test(zipCode)) {
    return false;
  }

  return getValidUsaZipCodeSet().has(zipCode);
}

const usaZipCode = z
  .string()
  .regex(usaZipCodePattern)
  .refine(isValidUsaZipCode, {
    message: "ZIP code must be a real US ZIP code",
  });

export { isValidUsaZipCode, normalizeUsaZipCode, usaZipCode };
